import { gql } from '@apollo/client';

export const REVENUE_REPORT = gql`
    query RevenueReport {
        revenueReport {
            months {
                year
                month
                invoicedMembership
                invoicedOther
                paidMembership
                paidOther
                invoicedByType {
                    key
                    label
                    parent
                    amount
                }
                paidByType {
                    key
                    label
                    parent
                    amount
                }
            }
            consumption {
                period
                total
                byType {
                    key
                    label
                    parent
                    amount
                }
            }
        }
    }
`;
